export default __webpack_public_path__ + "static/media/oldSite.1a9b5371.gif";